"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportFilter = void 0;
var ReportFilter;
(function (ReportFilter) {
    let operator;
    (function (operator) {
        operator["EQUALS"] = "equals";
        operator["NOT_EQUALS"] = "not_equals";
        operator["GREATER_THAN"] = "greater_than";
        operator["GREATER_THAN_OR_EQUAL_TO"] = "greater_than_or_equal_to";
        operator["LESS_THAN"] = "less_than";
        operator["LESS_THAN_OR_EQUAL_TO"] = "less_than_or_equal_to";
        operator["BETWEEN"] = "between";
        operator["INCLUDES"] = "includes";
        operator["EXCLUDES"] = "excludes";
        operator["NOT_ZERO"] = "not_zero";
        operator["EXISTS"] = "exists";
        operator["IS_TRUE"] = "is_true";
        operator["IS_FALSE"] = "is_false";
        operator["LAST_DAY"] = "last_day";
        operator["LAST_WEEK"] = "last_week";
        operator["LAST_MONTH"] = "last_month";
    })(operator = ReportFilter.operator || (ReportFilter.operator = {}));
})(ReportFilter = exports.ReportFilter || (exports.ReportFilter = {}));
